import { BidType } from '@/features/bidding/constants'
import { useBidUpdateOverviewQuery } from '@/features/bidding/hooks/useBidUpdateOverviewQuery'
import type { GroupedBidParams } from '@/features/bidding/utils/groupedBidParams/buildBiddingLinks'

type Response = {
  isLoading: boolean
  hasBidUpdates: boolean
}

export function useHasBidUpdates(bidType: BidType, groupParams?: GroupedBidParams | null): Response {
  const { isLoading, bidUpdateOverview } = useBidUpdateOverviewQuery(
    {
      portfolioCode: groupParams?.portfolioCode,
      marketProgram: groupParams?.marketProgram,
      deliveryDay: groupParams?.deliveryDay,
      bidType,
    },
    { enabled: !!groupParams },
  )

  return {
    isLoading,
    hasBidUpdates: (bidUpdateOverview?.length ?? 0) > 0,
  }
}

export function useHasCapacityBidUpdates(groupParams?: GroupedBidParams | null): Response {
  return useHasBidUpdates(BidType.CAPACITY, groupParams)
}

export function useHasEnergyBidUpdates(groupParams?: GroupedBidParams | null): Response {
  return useHasBidUpdates(BidType.ENERGY, groupParams)
}
